import Vue from 'vue'
import Router from 'vue-router'
import login from '@/router/modules/login' //登录模块
import pattern from '@/router/modules/pattern' //多语模式
import teachers from '@/router/modules/teachers'//多语师资
import administration from '@/router/modules/administration'//规范管理
import index from '@/router/modules/index'//首页
import concat from '@/router/modules/concat'
import personal from '@/router/modules/personal'//个人中心
import recuit from './modules/recuit'//行业招聘
import shop from './modules/shop' // 官方商城
import solution from './modules/solution' // 解决方案
import store from '@/store/index'
import testIndex from '@/views/test-index.vue'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
	routes: [
		{
			path: "/test",
			component: testIndex,
		},
		...solution,
		...shop,
		...login,
		...pattern,
		...teachers,
		...administration,
		...index,
		...concat,
		...personal,
		...recuit
	]
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
	// console.log('running in router.beforeEach')
	// console.log(to.meta.metaInfo)
	if (to.meta.metaInfo) {
		store.commit("metaModule/CHANGE_META_INFO", to.meta.metaInfo)
	} else {
		store.commit("metaModule/CHANGE_META_INFO", {
			title: "幼儿多语教育在线",
			keywords: "",
			description: "",
		})
	}
	next()
})
  
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js